// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-padding {
  padding: 12px;
}

.ion-margin {
  margin: 12px;
}

app-modal-info {
  height: 100vh;
  position: relative;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--randy-beige);
}

swiper-slide {
  width: 100% !important;
}

.image-wrapper {
  width: 100%;
  position: relative;
  border-bottom: 0.5px solid #939393;
}
.image-wrapper ion-img {
  aspect-ratio: 512/316;
  border-radius: 2px;
  overflow: hidden;
}
.image-wrapper ion-img:not(.default-img) {
  object-fit: cover;
  max-height: 180px;
  margin: 0 auto;
}
.image-wrapper .default-img {
  background-color: #fff;
  padding: 15px;
}
.image-wrapper .info-product-icon {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
  padding-bottom: 120px;
}

.option-group-col {
  flex-shrink: 1;
  flex-basis: auto;
  margin-top: 10px;
  padding: 0 11px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-btn {
  cursor: pointer;
  position: absolute;
  margin: 0;
  font-size: 40px;
  top: 10px;
  left: 10px;
  z-index: 1;
}

ion-toolbar {
  --ion-toolbar-color: white;
  --ion-toolbar-background: var(--ion-color-primary);
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  height: 36px;
  width: 36px;
  padding: 8px;
}

.menge {
  margin-inline: 16px;
  padding: 20px 0 !important;
  border-top: 0.5px solid #311802;
  border-bottom: 0.5px solid #311802;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menge h5 {
  font-family: AppFontSemiBold;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.8px;
  text-align: left;
  color: #1e1e1c;
}

.select-size {
  text-align: left;
  padding: 10px 25px !important;
  display: flex;
  flex-direction: column;
}
.select-size ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.info {
  text-align: left;
  padding: 24px 16px !important;
}
.info .title {
  margin: 0px 0px 3px;
  font-weight: 500;
  font-size: 24px;
  line-height: 32.8px;
  text-align: left;
  font-family: AppFont;
  color: var(--randy-gray);
}
.info .desc {
  font-size: 12px;
  line-height: 16.25px;
  letter-spacing: 0.02em;
  text-align: left;
  font-weight: 300;
}
.info .measurement {
  font-size: 12px;
  line-height: 110%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.title > span {
  display: inline-flex;
  align-items: center;
}

.info-icon {
  margin-left: 5px;
  position: relative;
  left: unset;
  right: unset;
  bottom: unset;
  top: unset;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.qty-row {
  margin: 10px 0;
}
.qty-row h2 {
  font-size: 18px;
}

.size-picker {
  margin-top: 20px;
}
.size-picker .chip {
  background: #f5f5f5;
  color: #000;
}
.size-picker .chip.selected {
  background: #000;
  color: #fff;
  font-weight: 500;
}

.step-counter {
  color: var(--ion-color-primary);
}

.first-toolbar {
  padding: 12px;
  backdrop-filter: blur(3px);
  color: black;
}

.option-group-description {
  margin: 20px 16px 0;
  color: #1e1e1c;
  font-family: AppFont;
  font-size: 16px;
  line-height: 21.6px;
  text-align: left;
}

.first-page-header {
  background: red;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  width: 100%;
}
.first-page-header ion-icon {
  zoom: 1.7;
  margin: 0px 5px;
  width: 8%;
}
.first-page-header ion-title {
  text-align: left;
}

.button-price {
  margin-left: 10px;
}

.header-block {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.header-block ion-icon {
  zoom: 0.6;
}

app-tag {
  margin-top: 7px;
  margin-bottom: 12px;
}

ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.footer-container {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 80px;
  width: 100%;
  z-index: 999;
  background: white;
  padding: 16px;
}

.footer-button {
  width: 100%;
  height: 54px;
  margin: 0;
  --background: var(--randy-red);
  --background-activated: var(--randy-red-dark);
  --background-hover: var(--randy-red-dark);
}
.footer-button span {
  font-family: AppFont;
  color: white;
  font-size: 14px;
  font-weight: 700;
  line-height: 19.2px;
  letter-spacing: 0.01em;
}

app-universal-page-toolbar {
  --title-width: 192px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss"],"names":[],"mappings":"AAIA;EACC,aAAA;AAHD;;AAMA;EACC,YAAA;AAHD;;AAMA;EACC,aAAA;EACA,kBAAA;AAHD;;AAMA;EACC,sBAAA;EACA,uBAAA;EACA,oCAAA;AAHD;;AAMA;EACC,sBAAA;AAHD;;AAMA;EACC,WAAA;EACA,kBAAA;EACA,kCAAA;AAHD;AAIC;EACC,qBAAA;EACA,kBAAA;EACA,gBAAA;AAFF;AAIE;EACC,iBAAA;EAEA,iBAAA;EACG,cAAA;AAHN;AAOC;EACC,sBAAA;EACA,aAAA;AALF;AAQC;EACC,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AANF;;AAUA;EACC,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;EACA,qBAAA;AAPD;;AAUA;EACC,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAPD;;AAUA;EACC,YAAA;EACA,cAAA;AAPD;;AAUA;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAPD;;AAUA;EACC,0BAAA;EACA,kDAAA;AAPD;AASC;EACC,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAPF;AAUC;EACC,YAAA;EACA,WAAA;EACA,YAAA;AARF;;AAWA;EACC,mBA1GgB;EA2GhB,0BAAA;EACA,+BAAA;EACA,kCAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AATD;AAWC;EACC,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACC,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;AATD;AAUC;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AARF;;AAWA;EACC,gBAAA;EACA,6BAAA;AARD;AAUC;EACC,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EAEA,oBAAA;EACG,wBAAA;AATL;AAYC;EACC,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAVF;AAaC;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAXF;;AAeA;EACC,oBAAA;EACA,mBAAA;AAZD;;AAeA;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAZD;;AAeA;EACC,cAAA;AAZD;AAcC;EACC,eAAA;AAZF;;AAgBA;EACC,gBAAA;AAbD;AAeC;EACC,mBAAA;EACA,WAAA;AAbF;AAeE;EACC,gBAAA;EACA,WAAA;EACA,gBAAA;AAbH;;AAkBA;EACC,+BAAA;AAfD;;AAkBA;EACC,aAAA;EACA,0BAAA;EACA,YAAA;AAfD;;AAkBA;EACC,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAfD;;AAkBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAfD;AAgBC;EACC,SAAA;EACA,eAAA;EACA,SAAA;AAdF;AAgBC;EACC,gBAAA;AAdF;;AAiBA;EACC,iBAAA;AAdD;;AAgBA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;AAbD;AAcC;EACC,SAAA;AAZF;;AAeA;EACC,eAAA;EACA,mBAAA;AAZD;;AAcA;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AAXD;;AAcA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AAXD;;AAcA;EACC,WAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;EACA,6CAAA;EACA,yCAAA;AAXD;AAaC;EACC,oBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAXF;;AAeA;EACC,oBAAA;AAZD","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\n$padding-inline: 16px;\n\n.ion-padding {\n\tpadding: 12px;\n}\n\n.ion-margin {\n\tmargin: 12px;\n}\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n}\n\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n\tbackground-color: var(--randy-beige);\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\n\n.image-wrapper {\n\twidth: 100%;\n\tposition: relative;\n\tborder-bottom: 0.5px solid #939393;\n\tion-img {\n\t\taspect-ratio: 512 / 316;\n\t\tborder-radius: 2px;\n\t\toverflow: hidden;\n\n\t\t&:not(.default-img) {\n\t\t\tobject-fit: cover;\n\t\t\t// object-position: 0px 77%;\n\t\t\tmax-height: 180px;\n   \t\t\tmargin: 0 auto;\n\t\t}\n\t}\n\n\t.default-img {\n\t\tbackground-color: #fff;\n\t\tpadding: 15px;\n\t}\n\n\t.info-product-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 5px;\n\t\tright: 6px;\n\t}\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: 0;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\toverflow: auto;\n\tpadding-bottom: 120px;\n}\n\n.option-group-col {\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tmargin-top: 10px;\n\tpadding: 0 ($padding-inline - 5px);\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-btn {\n\tcursor: pointer;\n\tposition: absolute;\n\tmargin: 0;\n\tfont-size: 40px;\n\ttop: 10px;\n\tleft: 10px;\n\tz-index: 1;\n}\n\nion-toolbar {\n\t--ion-toolbar-color: white;\n\t--ion-toolbar-background: var(--ion-color-primary);\n\n\tion-button {\n\t\t--background: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--background-hover: transparent;\n\t}\n\n\tion-icon {\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tpadding: 8px;\n\t}\n}\n.menge {\n\tmargin-inline: $padding-inline;\n\tpadding: 20px 0 !important;\n\tborder-top: 0.5px solid #311802;\n\tborder-bottom: 0.5px solid #311802;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\th5 {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tline-height: 21.8px;\n\t\ttext-align: left;\n\t\tcolor: #1e1e1c;\n\t}\n}\n.select-size {\n\ttext-align: left;\n\tpadding: 10px 25px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tion-item {\n\t\tborder-radius: 5px;\n\t\tmargin-top: 10px;\n\t\tborder: 0.5px solid #e2dcd5;\n\t}\n}\n.info {\n\ttext-align: left;\n\tpadding: 24px $padding-inline !important;\n\n\t.title {\n\t\tmargin: 0px 0px 3px;\n\t\tfont-weight: 500;\n\t\tfont-size: 24px;\n\t\tline-height: 32.8px;\n\t\ttext-align: left;\n\n\t\tfont-family: AppFont;\n    \tcolor: var(--randy-gray);\n\t}\n\n\t.desc {\n\t\tfont-size: 12px;\n\t\tline-height: 16.25px;\n\t\tletter-spacing: 0.02em;\n\t\ttext-align: left;\n\t\tfont-weight: 300;\n\t}\n\n\t.measurement {\n\t\tfont-size: 12px;\n\t\tline-height: 110%;\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.title > span {\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n\n.info-icon {\n\tmargin-left: 5px;\n\tposition: relative;\n\tleft: unset;\n\tright: unset;\n\tbottom: unset;\n\ttop: unset;\n\twidth: 30px;\n\theight: 30px;\n\tcursor: pointer;\n}\n\n.qty-row {\n\tmargin: 10px 0;\n\n\th2 {\n\t\tfont-size: 18px;\n\t}\n}\n\n.size-picker {\n\tmargin-top: 20px;\n\n\t.chip {\n\t\tbackground: #f5f5f5;\n\t\tcolor: #000;\n\n\t\t&.selected {\n\t\t\tbackground: #000;\n\t\t\tcolor: #fff;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n\n.step-counter {\n\tcolor: var(--ion-color-primary);\n}\n\n.first-toolbar {\n\tpadding: 12px;\n\tbackdrop-filter: blur(3px);\n\tcolor: black;\n}\n\n.option-group-description {\n\tmargin: 20px $padding-inline 0;\n\tcolor: #1e1e1c;\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tline-height: 21.6px;\n\ttext-align: left;\n}\n\n.first-page-header {\n\tbackground: red;\n\theight: 60px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: white;\n\twidth: 100%;\n\tion-icon {\n\t\tzoom: 1.7;\n\t\tmargin: 0px 5px;\n\t\twidth: 8%;\n\t}\n\tion-title {\n\t\ttext-align: left;\n\t}\n}\n.button-price {\n\tmargin-left: 10px;\n}\n.header-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: start;\n\tion-icon {\n\t\tzoom: 0.6;\n\t}\n}\napp-tag {\n\tmargin-top: 7px;\n\tmargin-bottom: 12px;\n}\nion-item {\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #e2dcd5;\n}\n\n.footer-container {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\theight: 80px;\n\twidth: 100%;\n\tz-index: 999;\n\tbackground: white;\n\tpadding: 16px;\n}\n\n.footer-button {\n\twidth: 100%;\n\theight: 54px;\n\tmargin: 0;\n\t--background: var(--randy-red);\n\t--background-activated: var(--randy-red-dark);\n\t--background-hover: var(--randy-red-dark);\n\n\tspan {\n\t\tfont-family: AppFont;\n\t\tcolor: white;\n\t\tfont-size: 14px;\n\t\tfont-weight: 700;\n\t\tline-height: 19.2px;\n\t\tletter-spacing: 0.01em;\n\t}\n}\n\napp-universal-page-toolbar {\n\t--title-width: 192px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
